import { render, staticRenderFns } from "./CafeteriaListTable.vue?vue&type=template&id=6b2aa6d8"
import script from "./CafeteriaListTable.vue?vue&type=script&lang=js"
export * from "./CafeteriaListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports